export const appSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers =
  "/internal_user_groups/:internal_user_group_id/test_users_v2";
